import { CartItemInterface, ProductInterface } from '@pylot-data/pylotschema'

export const identifyCartProductsCategories = (
    cartItems: CartItemInterface[] | [],
    urlPath: string | string[] | undefined
): CartItemInterface[] | [] => {
    return cartItems.map((cartItem) => {
        const { product } = cartItem

        return {
            ...cartItem,
            product: {
                ...product,
                category: {
                    name: getProductCategoryName(product, urlPath)
                }
            }
        }
    })
}

const getProductCategoryName = (
    product: ProductInterface,
    urlPath: string | string[] | undefined
): string => {
    if (urlPath) {
        const path = Array.isArray(urlPath) ? urlPath.join('/') : urlPath
        return (
            product.categories?.find((category) => category?.url_path === path)
                ?.name || ''
        )
    }

    return ''
}
